<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-number-box  [label]="'entity.resourceAllocation.cycle' | translate | ucfirst" formControlName="cycleQuantity" formField required></dx-number-box>
  <gs-time-span-field
                      [label]="'entity.resourceAllocation.setup' | translate"
                      formField required formControlName="setup"
  />
  <gs-time-span-field
    [label]="'entity.resourceAllocation.cycleDuration' | translate | ucfirst"
    formField required formControlName="process"
  />
  <gs-time-span-field
    [label]="'entity.resourceAllocation.teardown' | translate | ucfirst"
    formField required formControlName="teardown"
  />
</form>
